import { render, staticRenderFns } from "./Sill.vue?vue&type=template&id=2ec25ef2"
import script from "./Sill.vue?vue&type=script&lang=js"
export * from "./Sill.vue?vue&type=script&lang=js"
import style0 from "./Sill.vue?vue&type=style&index=0&id=2ec25ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports